import { Component, Inject, Input, OnInit, Optional } from '@angular/core';

import IZoningCode = ZoningAPI.IZoningCode;
import IZoningCodeStatistic = ZoningAPI.IZoningCodeStatistic;
import IZoningCodeRecord = ZoningAPI.IZoningCodeRecord;
import * as _ from 'lodash';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'app-zc-details-view',
    templateUrl: './zc-details-view.component.html',
    styleUrls: ['./zc-details-view.component.scss']
})
export class ZCDetailsViewComponent implements OnInit {
    @Input()
    public zoningCode: IZoningCode;

    zcStatistic: IZoningCodeStatistic;
    zoningCodeRecord: IZoningCodeRecord;

    constructor(
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: IZoningCode
    ) {}

    ngOnInit() {
        const zoningCode = this.data || this.zoningCode;
        this.zcStatistic = _.get(zoningCode, 'taskOrStatistic');
        this.zoningCodeRecord = _.get(zoningCode, 'ZoningCodeRecord');
    }
}
